import { getCookie, setLocalCookies } from "../utils/cookieManager";
import { getCookieDomain } from "../utils/config";
import { refreshToken } from "./refreshToken";
import { getDecodedToken } from "../utils/jwtDecoder";
import { emit } from "../utils/eventManager";
import { getBroadcastChannel } from "../utils/broadcastChannel";
export { setTokens, checkRefresh };
var a_second = 1000;
var handle;
async function setTokens(args) {
  var idToken = args.idToken,
    accessToken = args.accessToken,
    _args$broadcast = args.broadcast,
    broadcast = _args$broadcast === void 0 ? true : _args$broadcast,
    authActionType = args.authActionType;
  var domain = getCookieDomain();
  if (domain) {
    setLocalCookies({
      idToken: idToken,
      accessToken: accessToken
    }, domain);
  }
  checkRefresh(accessToken);
  emit('tokens', {
    idToken: idToken,
    accessToken: accessToken
  }, authActionType);
  if (broadcast && getBroadcastChannel() !== null) {
    getBroadcastChannel().postMessage({
      action: 'setTokens',
      payload: {
        idToken: idToken,
        accessToken: accessToken
      }
    });
  }
}
function checkCookies() {
  if (!getCookie('id_token')) {
    emit('logout.success');
    return false;
  }
  return true;
}
function checkRefresh(access_token) {
  var _getDecodedToken;
  if (!access_token) {
    access_token = getCookie('access_token') || '';
  }
  var exp = (_getDecodedToken = getDecodedToken(access_token)) === null || _getDecodedToken === void 0 ? void 0 : _getDecodedToken.exp;
  var rnd = Math.floor(Math.random() * 15);
  clearTimeout(handle);
  if (!exp) {
    if (checkCookies()) {
      refreshToken();
    }
    return;
  }
  var now = Date.now();
  var diff = exp - now / 1000;
  if (diff < 120) {
    handle = setTimeout(refreshToken, rnd * 10); // calls refresh if diff is in the last 2 minutes before exp
  } else {
    // since when chrome pauses timers on standby, we need to check more frequently rather than use the token's expiry
    // as an indicator
    handle = setTimeout(checkRefresh, (30 + rnd) * a_second); // calls checkRefresh every 30s
  }
}